import { instance } from "@/apis";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

/**
 * 채팅 스트리밍 중단 API를 호출하는 mutation 훅
 * 
 * stop은 채팅 종료가 아니라 스트리밍 중단 신호만 서버에 전달
 * 
 * @returns {UseMutationResult} React Query mutation 객체
 */
export const useStopChatMutation = () => {
  return useMutation({
    /**
     * 채팅 스트리밍 중단 API 호출 함수
     * @param {string} chatId - 중단할 채팅의 ID
     * @returns {Promise} API 응답 Promise
     */
    mutationFn: async (chatId: string) => {
      return instance.post(`/api/df/user/chat/isg/stop`, {
        chatId,
      });
    },
    
    onSuccess: (res) => {
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
};
